import headerModules from "./modules/headerModules";
import indexNav from "./modules/indexNav";
import accordion from './modules/accordion';
import smoothscroll from "./modules/smoothscroll";
import tabContent from "./modules/tabContent";
import tableContent from "./modules/tableContent";
import slider from './modules/slider';
import zoomImage from './modules/zoomImage';
import blockEditor from './modules/blockEditor';
import documentPageModules from './modules/documentPageModules';
import modal from './modules/modal';
import youtube from './modules/youtube';

document.addEventListener('DOMContentLoaded', () => {
  headerModules();
  blockEditor();
  tabContent();
  indexNav();
  smoothscroll();
  accordion();
  documentPageModules();
  modal();
  zoomImage();
  youtube();
  setTimeout(() => {
    tableContent();
  });
});

window.addEventListener('load', () => {
  slider();
});
